import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { StatusPill } from '@lyearn/ui';
import { StatusPillSize } from '@lyearn/ui/dist/esm/Pill/StatusPill/types';
import { JobEntityStatusEnum, JourneyStatusEnum, ResourceStatusEnum } from '@/types/schema';
import { RESOURCE_STATUS_PILL_CONFIG } from '@/utils/resourceStatusPillConfig';

import GeneratingStatusLabel from '../GeneratingStatusLabel';

function StatusLabel({
  status,
  size,
  jobProgress,
}: {
  status?: ResourceStatusEnum | JourneyStatusEnum | JobEntityStatusEnum | null;
  size?: StatusPillSize;
  /** 0 to 100 */
  jobProgress?: number;
}) {
  const { t } = useTranslation();

  if (!status || status === ResourceStatusEnum.Published) {
    return null;
  }

  if (status === JobEntityStatusEnum.InProcess) {
    return <GeneratingStatusLabel jobProgress={jobProgress} size={size} />;
  }

  const tag = RESOURCE_STATUS_PILL_CONFIG[status];

  if (!tag) {
    return null;
  }

  return <StatusPill appearance={tag.appearance} label={t(tag.key)} size={size} variant="light" />;
}

export default React.memo(StatusLabel);
